import pbfe from "./pbfe.js";
import { _, t } from "./i18n.js";
import createNavbar from "./navbar.js";
import { LANG_URL_MAP, getLang, navigate } from "./index.js";

var container, box;

function init(_container) {
    container = _container;

    box = new pbfe.Flexbox("column");
    box.element.id = "contactScreen";
    box.element.className = "main-screen";

    // Navbar
    var navbar = createNavbar();
    box.appendChild(navbar);

    // Content Container
    var contentBox = new pbfe.Flexbox("column");
    contentBox.element.id = "contactContentBox";
    contentBox.alignItems = "center";

    // Breadcrumb
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";

    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);

    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    t(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", () => {
        var lang = getLang();
        var prefix = LANG_URL_MAP[lang];
        navigate(prefix ? "/" + prefix : "/");
    });
    breadcrumb.appendChild(homeLink);

    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);

    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    t(current, "Contact");
    breadcrumb.appendChild(current);

    contentBox.appendChild(breadcrumbContainer);

    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    t(title, "Contact Us");
    contentBox.appendChild(title);

    // Content card
    var card = document.createElement("div");
    card.className = "about-page-container about-page-content";
    card.style.textAlign = "center";
    card.insertAdjacentHTML("beforeend", `
        <p class="about-tagline">We'd love to hear from you.</p>
        <p class="about-desc">Whether you have a question about the tool, feedback, a partnership idea, or a privacy request, the fastest way to reach us is by email.</p>
        <div class="contact-method">
            <div class="contact-icon">✉️</div>
            <div class="contact-label">Email</div>
            <a class="contact-value" href="mailto:support@avatarcropper.app">support@avatarcropper.app</a>
        </div>
        <p class="about-desc" style="margin-top:1.5rem;">We aim to respond to all inquiries within 2–3 business days. For privacy-related requests, please mention "Privacy" in your subject line.</p>
    `);
    contentBox.appendChild({ element: card });
    box.appendChild(contentBox);
}

function show() {
    container.appendChild(box);
    setTimeout(() => box.element.classList.add("show"), 0);
}

function hide() {
    if (!box) return;
    box.element.classList.remove("show");
    if (container && container.contains(box)) {
        container.removeChild(box);
    }
}

var contactScreen = {
    init, show, hide
};

export default contactScreen;
